export class ViewPortSizeProvider {
    public canvasWidth: number;
    public canvasHeight: number;

    constructor(canvasWidth: number = window.innerWidth, canvasHeight: number = window.innerHeight) {
        this.canvasWidth = canvasWidth;
        this.canvasHeight = canvasHeight;
    }
}
